export const userDetail = {
    "camila.rodríguez": {
      "Size": "L",
      "Footwear Size": "5",
    },
    "emily.parker": {
      "Size": "M",
      "Footwear Size": "5.5",
    },
    "rachel.sanders": {
      "Size": "L",
      "Footwear Size": "6",
    },
    "abigail.coleman": {
      "Size": "S",
      "Footwear Size": "6",
    },
    "lauren.mitchell": {
      "Size": "M",
      "Footwear Size": "6",
    },
    "apsara.chaiyaporn": {
      "Size": "M",
      "Footwear Size": "5",
    },
    "advika.gupta": {
      "Size": "M",
      "Footwear Size": "7",
    },
    "may.phan": {
      "Size": "S",
      "Footwear Size": "5",
    },
    "isabela.torres": {
      "Size": "L",
      "Footwear Size": "6",
    },
    "megan.brooks": {
      "Size": "L",
      "Footwear Size": "7",
    },
  };
  